/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const visitVoiceRecordings = sqliteTable('visit_voice_recordings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  encounter_id: text('encounter_id'),
  appointment_id: text('appointment_id'),
  conversation_id: text('conversation_id'),
  section_key: text('section_key'),
  storage_path: text('storage_path'),
  mime_type: text('mime_type'),
  original_filename: text('original_filename'),
  size_bytes: integer('size_bytes'),
  duration_ms: integer('duration_ms'),
  transcript: text('transcript'),
  transcript_language: text('transcript_language'),
  transcription_status: text('transcription_status'),
  transcription_error: text('transcription_error'),
  upload_status: text('upload_status'),
  recorded_at: text('recorded_at'),
  recorded_by: text('recorded_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
